'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerSupportContainer = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    font-size: 30px;\n  '], ['\n    font-size: 30px;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    margin-top: 200px;\n  '], ['\n    margin-top: 200px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    margin-top: 110px;\n  '], ['\n    margin-top: 110px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    margin: 50px auto;\n  '], ['\n    margin: 50px auto;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    display: block !important;\n    top: 0;\n    left: 0;\n  '], ['\n    display: block !important;\n    top: 0;\n    left: 0;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    left: -8%;\n  '], ['\n    left: -8%;\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    width: 65%;\n    margin-top: 0;\n  '], ['\n    width: 65%;\n    margin-top: 0;\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    width: 20%;\n    margin-right: 5%;\n    > img {\n      display: none;\n    }\n  '], ['\n    width: 20%;\n    margin-right: 5%;\n    > img {\n      display: none;\n    }\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject11 = _taggedTemplateLiteral(['\n    flex-direction: column;\n    margin-left: 0 !important;\n    > div {\n      display: flex;\n      flex-direction: row-reverse;\n      width: 100%;\n      max-width: 100%;\n      justify-content: flex-end;\n      padding: 0;\n    }\n    h5 {\n      font-size: 1em;\n      margin-left: 1em;\n      text-align: left;\n    }\n  '], ['\n    flex-direction: column;\n    margin-left: 0 !important;\n    > div {\n      display: flex;\n      flex-direction: row-reverse;\n      width: 100%;\n      max-width: 100%;\n      justify-content: flex-end;\n      padding: 0;\n    }\n    h5 {\n      font-size: 1em;\n      margin-left: 1em;\n      text-align: left;\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _colors = require('HubStyleTokens/colors');

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UIGrid = require('UIComponents/grid/UIGrid');

var _UIGrid2 = _interopRequireDefault(_UIGrid);

var _UIGridItem = require('UIComponents/grid/UIGridItem');

var _UIGridItem2 = _interopRequireDefault(_UIGridItem);

var _cindy = require('bender-url!pricing-pages-unified-ui/img/peopleBlobs/cindy.png');

var _cindy2 = _interopRequireDefault(_cindy);

var _gyasi = require('bender-url!pricing-pages-unified-ui/img/peopleBlobs/gyasi.png');

var _gyasi2 = _interopRequireDefault(_gyasi);

var _meri = require('bender-url!pricing-pages-unified-ui/img/peopleBlobs/meri.png');

var _meri2 = _interopRequireDefault(_meri);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Title = _styledComponents2.default.h1.withConfig({
  displayName: 'CustomerSupport__Title'
})(['font-weight:bold;line-height:44px;', ';'], _responsiveBreakpoints2.default.phone(_templateObject));

var CustomerSupportContainer = exports.CustomerSupportContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CustomerSupport__CustomerSupportContainer'
})(['position:relative;z-index:1;display:block;margin:140px 0;', ';', ';', ';'], _responsiveBreakpoints2.default.cs(_templateObject2), _responsiveBreakpoints2.default.tablet(_templateObject3), _responsiveBreakpoints2.default.phone(_templateObject4));

var GyasiImg = (0, _styledComponents2.default)(_UIImage2.default).withConfig({
  displayName: 'CustomerSupport__GyasiImg'
})(['position:absolute;left:220px;top:160px;', ';', ';'], _responsiveBreakpoints2.default.cs(_templateObject5), _responsiveBreakpoints2.default.tablet(_templateObject6));

var WordWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'CustomerSupport__WordWrapper'
})(['width:580px;float:right;margin-top:20%;', ';', ';'], _responsiveBreakpoints2.default.cs(_templateObject7), _responsiveBreakpoints2.default.tabletPortrait(_templateObject8));

var ImageWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'CustomerSupport__ImageWrapper'
})(['float:left;', ';', ';'], _responsiveBreakpoints2.default.cs(_templateObject9), _responsiveBreakpoints2.default.tabletPortrait(_templateObject10));

var CustomerSupportMicroCopy = (0, _styledComponents2.default)(_Small2.default).withConfig({
  displayName: 'CustomerSupport__CustomerSupportMicroCopy'
})(['text-transform:uppercase;font-weight:500;']);

var IconsWrapper = (0, _styledComponents2.default)(_UIGrid2.default).withConfig({
  displayName: 'CustomerSupport__IconsWrapper'
})(['text-align:center;margin-top:49px;margin-left:-32px !important;margin-right:0 !important;', ';'], _responsiveBreakpoints2.default.phone(_templateObject11));

function CustomerSupport() {
  return _react2.default.createElement(
    CustomerSupportContainer,
    null,
    _react2.default.createElement(
      ImageWrapper,
      null,
      _react2.default.createElement(_UIImage2.default, { src: _meri2.default, width: 280 }),
      _react2.default.createElement(GyasiImg, { src: _gyasi2.default, width: 280 }),
      _react2.default.createElement(_UIImage2.default, { src: _cindy2.default, width: 280, className: 'm-top-8' })
    ),
    _react2.default.createElement(
      WordWrapper,
      null,
      _react2.default.createElement(
        CustomerSupportMicroCopy,
        { use: 'help' },
        _react2.default.createElement(_FormattedMessage2.default, { message: 'customerSupport.title' })
      ),
      _react2.default.createElement(
        Title,
        null,
        _react2.default.createElement(_FormattedMessage2.default, { message: 'customerSupport.subtitle' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'm-bottom-8' },
        _react2.default.createElement(_FormattedMessage2.default, { message: 'customerSupport.description' })
      ),
      _react2.default.createElement(
        IconsWrapper,
        null,
        _react2.default.createElement(
          _UIGridItem2.default,
          { size: { xs: 4 } },
          _react2.default.createElement(
            'h5',
            null,
            _react2.default.createElement(_FormattedMessage2.default, { message: 'customerSupport.phoneAndEmail' })
          ),
          _react2.default.createElement(_UIIcon2.default, { color: _colors.EERIE, name: 'calling', size: 28 })
        ),
        _react2.default.createElement(
          _UIGridItem2.default,
          { size: { xs: 4 } },
          _react2.default.createElement(
            'h5',
            null,
            _react2.default.createElement(_FormattedMessage2.default, { message: 'customerSupport.documentation' })
          ),
          _react2.default.createElement(_UIIcon2.default, { color: _colors.EERIE, name: 'blog', size: 28 })
        ),
        _react2.default.createElement(
          _UIGridItem2.default,
          { size: { xs: 4 } },
          _react2.default.createElement(
            'h5',
            null,
            _react2.default.createElement(_FormattedMessage2.default, { message: 'customerSupport.community' })
          ),
          _react2.default.createElement(_UIIcon2.default, { color: _colors.EERIE, name: 'lists', size: 28 })
        )
      )
    )
  );
}

exports.default = CustomerSupport;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/CustomerSupport.js
// module id = 214
// module chunks = 3 4